import { baseEnvironment, METADATA_WRITER } from "./environment.base";
import { Environment } from "./types";

export const environment: Environment = {
  ...baseEnvironment,
  ENV: "staging",
  name: "Staging",
  AUTH_CLIENT_ID: "3b3833a4-0eeb-4cdd-b1f0-a48123b2c744",
  AUTH_FORCE_LICENSE: true,
  AUTH_FORCE_ORGANIZATION: true,
  PROTECTED_URIS: {
    ASSET_MODULE: "https://asset-module.api.ca.connect.stg-evcnt.com/api/v1",
    VISOL_API: "https://visol.connect.stg-evcnt.com/api"
  },
  ASSET_MODULE_OFFLINE: "http://localhost:5100/api/v1",
  VISOL_WEBSITE: "https://visol.connect.stg-evcnt.com",
  reportTemplateBuilderUrl: "https://rtb.connect.stg-evcnt.com/",
  powerBiEndpointUrl: "https://app.powerbi.com/",
  METADATA_WRITER,
  CONNECTORS: {
    GENERAL_ELECTRIC: "5bcb6742-2b65-46a1-a245-b60aa9c8c817"
  }
};
